module.exports = __webpack_public_path__ + "static/img/by.f4cbd761.svg";